// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Resizable } from "react-resizable";
import RawBytesOutputList from "./RawBytesOutputList";
import "../../../command_center/components/center/modals/console/Console.scss";

interface IProps {
  loading: boolean;
  error: string | null;
  commandDetails: any | null;
  getCommandDetails: (commandId: string) => void;
  set_resizing: (resizing: boolean) => void;
}

const RawBytesOutputSection: React.FC<IProps> = ({ set_resizing }) => {
  const [outputModalSize, setOutputModalSize] = React.useState<{
    width: number;
    height: number;
    resizing: boolean | string;
  }>({
    width: 500,
    height: 1000,
    resizing: false,
  });

  const [selectedRow, setSelectedRow] = React.useState<any>(null);
  const [hexString, setHexString] = React.useState<any>("");
  const [isOutputModalVisible, setIsOutputModalVisible] = useState<boolean>(false);
  const [entries, setEntries] = useState([]);

  const show_selected_output_details = (selected_command: any) => {
    const already_selected = selectedRow?.CommandUid === selected_command?.CommandUid;
    setSelectedRow(already_selected ? null : selected_command);
    if (!already_selected) {
      updateHexAndPayload(selected_command);
    } else {
      setHexString("");
    }
  };

  const updateHexAndPayload = (selected_command: any) => {
    const base64String = selected_command?.["CommandDetails"]?.completeFrame || "";
    setHexString(base64ToHex(base64String));
    setIsOutputModalVisible(true);
  };

  const onResizeHeight = (event, { size, handle }) => {
    event.stopPropagation();
    if (size.height >= 100 && size.height <= 500) {
      setOutputModalSize((prev) => ({
        ...prev,
        height: size.height,
        resizing: "height",
      }));
    }
  };

  const onResizeStop = (event: MouseEvent) => {
    event.stopPropagation();
    set_resizing(false);
    setOutputModalSize((prev) => ({
      ...prev,
      resizing: false,
    }));
  };

  const onResizeStart = (event: MouseEvent) => {
    event.stopPropagation();
    set_resizing(true);
  };

  const base64ToHex = (str: string): string => {
    const raw = atob(str);
    let result = "";
    for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += hex.length === 2 ? hex : "0" + hex;
      result += " ";
    }
    return result.toUpperCase();
  };

  useEffect(() => {
    const clearFormFields = () => {
      setSelectedRow(null);
      setHexString("");
      setIsOutputModalVisible(false);
    };

    window.addEventListener("clearFormFields", clearFormFields);
    return () => {
      window.removeEventListener("clearFormFields", clearFormFields);
    };
  }, []);

  return (
    <div className="right__panel__body__content__container right__panel__table__width modal__scrollbar__white__horizontal">
      <div className="content__container__table__header gap-3" style={{ justifyContent: "flex-start" }}>
        <div className="d-flex align-items-center justify-content-between" style={{ width: "160px" }}>
          <span>Received Time</span>
        </div>
        <div className="d-flex align-items-center justify-content-between" style={{ width: "850px" }}>
          <span>Data</span>
        </div>
      </div>
      <Resizable
        className="position-relative"
        height={outputModalSize.height}
        onResizeStop={onResizeStop}
        onResizeStart={onResizeStart}
        onResize={onResizeHeight}
        handle={(handleAxis, ref) => (
          <div ref={ref} className={`container__table__body__resize__handler ${outputModalSize.resizing === "height" && "active"} handle-${handleAxis}`} />
        )}
      >
        <div style={{ height: outputModalSize.height + 20, overflowY: entries?.length === 0 || !entries ? "hidden" : "" }}>
          <div className="content__container__table__body">
            <RawBytesOutputList
              height={outputModalSize.height}
              show_selected_output_details={show_selected_output_details}
              selectedRow={selectedRow}
              isOutputModalVisible={isOutputModalVisible}
              setEntries={setEntries}
              entries={entries}
              base64ToHex={base64ToHex}
            />
          </div>
        </div>
      </Resizable>
      {isOutputModalVisible && hexString && (
        <div className={`output__modal`}>
          <div className="output__modal__header__console">
            <div className="output__modal__header__console__options__container">
              <button className="output__modal__header__console__option active">MESSAGES</button>
            </div>
            <div className="output__modal__header__console__actions_btns">
              <button className="" style={{ background: "transparent" }} onClick={() => setIsOutputModalVisible(false)}>
                ✕
              </button>
            </div>
          </div>
          <div className="output__modal__right__sectio w-100">
            <div
              onMouseDown={(e) => {
                e.stopPropagation();
              }}
              onSelectStart={(e) => {
                e.stopPropagation();
              }}
            >
              {hexString ? hexString : "Not available"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RawBytesOutputSection;

